import io from 'socket.io-client';
import { apiBaseUrl } from './fetch';

let socket = io( apiBaseUrl );

export default socket;